module.exports = __webpack_public_path__ + "static/3-74a84215bde004568a3ffd6ed31dab1a.jpg";